module.exports = __webpack_public_path__ + "static/media/img_submit.3ad05a70.svg";